<ng-container
  *ngIf="{
    currentStatus: currentStatus$ | async,
    positiveStatuses: positiveStatuses$ | async,
  } as data"
>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-item [style.background-color]="data.currentStatus?.color">
          <div *ngIf="data.currentStatus.isPositive()" class="statusWrapper">
            <ng-container *ngFor="let status of data.positiveStatuses; let last = last">
              <div
                [style.background-color]="status.color"
                class="status-colored"
                [ngClass]="status.id === data.currentStatus.id ? 'active' : 'inactive'"
              >
                {{ status.humanReadableName }}
              </div>
              <div *ngIf="!last" class="connector"></div>
            </ng-container>
          </div>

          <ng-container *ngIf="data.currentStatus.isNegative()">
            <div [style.background-color]="data.currentStatus.color" class="status-colored active">
              {{ data.currentStatus.humanReadableName }}
            </div>
          </ng-container>

          <ng-container *ngIf="editable">
            <ion-buttons slot="end">
              <ion-button
                *ngIf="data.currentStatus.name === AssistanceStatusName.HAS_ASSISTANT"
                fill="outline"
                data-cy="btnSendToAssistant"
                (click)="advanceStatus()"
                [disabled]="!formStatus?.isSaved()"
              >
                <ion-icon name="chevron-forward-outline"></ion-icon>
                Zaslat asistentovi
              </ion-button>
              <ion-button
                *ngIf="data.currentStatus.name === AssistanceStatusName.SENT_TO_ASSISTANT"
                fill="outline"
                data-cy="btnConfirm"
                (click)="advanceStatus()"
                [disabled]="!formStatus?.isSaved()"
              >
                <ion-icon name="chevron-forward-outline"></ion-icon>
                Potvrdit
              </ion-button>

              <ion-button
                *ngIf="canShowStatusButtonCancel(data.currentStatus)"
                color="danger"
                fill="outline"
                data-cy="btnCancel"
                (click)="requestCancel()"
                [disabled]="!formStatus?.isSaved()"
              >
                <ion-icon name="close-outline"></ion-icon>
                Zrušit
              </ion-button>
            </ion-buttons>
          </ng-container>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
</ng-container>
